module.exports = __webpack_public_path__ + "img/about1.2860f07e.png";